import React, { useState } from "react";
import useHttpRequests from "../../../hooks/useHttpRequests";
import { TableWithStickyHeader } from "../../uiControls/tableWithStickyHeader";
import { FileTypeUpdate } from "./fileTypeUpdate";
import { FileTypeAdd } from "./fileTypeAdd";
import { ConfirmationDialog } from "../../common/confirmationDialog";
import { AddNew } from "../../uiControls/addNew";

const fileTypeColumns = [
  {
    label: "Name",
    keyField: "fileTypeKey",
    dataField: "name",
  },
  {
    label: "Description",
    keyField: "fileTypeKey",
    dataField: "description",
  },
  // {
  //   label: "Status",
  //   keyField: "fileTypeKey",
  //   dataField: "active",
  //   minWidth: 20,
  //   maxWidth: 20,
  // },
  {
    label: "",
    keyField: "fileTypeKey",
    dataField: "fileTypeKey",
    minWidth: 20,
    maxWidth: 20,
  },
];

const fileTypeSearchColumns = ["name", "description"];

export const FileTypeConfig = () => {
  const [updateOpen, setUpdateOpen] = useState(false);
  const [fileTypeEdit, setFileTypeEdit] = useState(null);
  const [fileTypeAttributes, setFileTypeAttributes] = useState({
    fileTypeKey: 0,
    name: "",
    description: "",
    active: true,
    fileColumns: [],
  });
  const [fileTypeColumnsAttributes, setFileTypeColumnsAttributes] = useState({
    columnKey: 0,
    columnNumber: 0,
    active: true,
    phi: true,
  });
  const [dialogOpen, setDialogOpen] = useState(false);
  const [confirmationDialogAttributes, setConfirmationDialogAttributes] =
    useState({});

  const { sendRequest: fetchFileTypeDetails } = useHttpRequests();

  const fileTypeEditHandler = (e, key) => {
    e.stopPropagation();
    if (updateOpen) {
      //alert("Are you sure to discard your changes?");
      //TODO: confirmation for data loss
      return false;
    }

    const getFileTypeDetails = (fileTypeObj) => {
      if (!fileTypeObj || !fileTypeObj.isSuccess || fileTypeObj.errorResponse) {
        console.log("File type fetch response returns error");
        return;
      }

      setFileTypeAttributes({
        fileTypeKey: fileTypeObj["fileType"]["fileTypeKey"],
        name: fileTypeObj["fileType"]["name"],
        description: fileTypeObj["fileType"]["description"],
        active: fileTypeObj["fileType"]["active"],
        fileColumns: fileTypeObj["fileType"]["fileColumns"],
      });
      setFileTypeColumnsAttributes(fileTypeObj["fileType"]["fileColumns"]);

      setFileTypeEdit(true);
      setUpdateOpen(true);
    };

    fetchFileTypeDetails(
      { url: "FileTypes/" + key, method: "GET", header: true },
      getFileTypeDetails
    );
  };

  const changeFileTypeStatus = (e, key, status, name) => {
    e.stopPropagation();
    if (updateOpen || dialogOpen) {
      return false;
    }
    setConfirmationDialogAttributes({
      title: "File type status change confirmation!",
      message:
        "Are you sure to mark " +
        (status ? "active" : "inactive") +
        " the " +
        name +
        "?",
      confirmText: "Yes",
      cancelText: "No",
      url: "FileTypes/",
      keyField: "fileTypeKey",
      key: key,
      status: status,
      messageTitle: name,
    });
    setDialogOpen(true);
  };

  const getUrl = (params) => {
    return "FileTypes";
  };

  const fileTypeDetailProps = {
    setUpdateOpen,
    fileTypeEdit,
    setFileTypeEdit,
    fileTypeAttributes,
    fileTypeColumnsAttributes,
  };

  return (
    <div
      style={{
        display: "flex",
        flexFlow: "column",
        height: "calc(100vh - 160px)",
      }}
    >
      <ConfirmationDialog
        open={dialogOpen}
        setDialogOpen={setDialogOpen}
        confirmationDialogAttributes={confirmationDialogAttributes}
      />
      <div
        style={{
          display: "flex",
          flexFlow: "column",
          gap: "20px",
          width: "100%",
        }}
      >
        {!updateOpen && (
          <>
            <TableWithStickyHeader
              pagging={false}
              columns={fileTypeColumns}
              url={getUrl}
              sourceObj="fileTypes"
              editHandler={fileTypeEditHandler}
              updateOpen={updateOpen}
              searchOnColumns={fileTypeSearchColumns}
              changeStatus={changeFileTypeStatus}
              searchPlace="right"
            />

            <AddNew
              onClickCall={() => {
                setFileTypeAttributes({
                  fileTypeKey: 0,
                  name: "",
                  description: "",
                  active: true,
                  fileColumns: [],
                });
                setFileTypeColumnsAttributes({
                  columnKey: 0,
                  columnNumber: 0,
                  active: true,
                  phi: true,
                });
                setUpdateOpen(true);
              }}
            />
          </>
        )}
      </div>

      {updateOpen && fileTypeEdit && (
        <div
          style={{
            display: "flex",
            width: "100%",
          }}
        >
          <FileTypeUpdate {...fileTypeDetailProps} />
        </div>
      )}
      {updateOpen && !fileTypeEdit && (
        <div
          style={{
            display: "flex",
            width: "100%",
          }}
        >
          <FileTypeAdd {...fileTypeDetailProps} />
        </div>
      )}
    </div>
  );
};
